import axios from "axios";

export const getTrackerProveedores = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tracker/proveedores`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener las notificaciones:", error);
  }
};

export const getTrackerProveedoresByEmpresa = async (API_URL, id_empresa) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/tracker/proveedores/empresa/${id_empresa}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener las notificaciones:", error);
  }
};

export const getTrackerProyectos = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tracker/proyectos`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener las notificaciones:", error);
  }
};

export const getTrackerProyectosByTrabajo = async (API_URL, id_trabajo) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/tracker/proyectos/trabajo/${id_trabajo}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener las notificaciones:", error);
  }
};

export const getNotifications = async (API_URL, user_id) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/notifications?user_id=${user_id}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al obtener las notificaciones:", error);
  }
};

export const createTrackerProyecto = async (API_URL, data) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/tracker/proyectos`,
      data,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al crear el tracker:", error);
    throw error;
  }
};

export const getTrackerProyectosEvents = async (API_URL, id_trabajo) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/tracker/proyectos/events/${id_trabajo}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al obtener los eventos del tracker del proyecto:",
      error
    );
    throw error;
  }
};

export const getTrackerProveedoresEvents = async (API_URL, id_empresa) => {
  try {
    const response = await axios.get(
      `${API_URL}/api/tracker/proveedores/events/${id_empresa}`,
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al obtener los eventos del tracker del proveedor:",
      error
    );
    throw error;
  }
};

export const updateTrackerEvent = async (
  API_URL,
  id_trabajo,
  etapa,
  estatus,
  detalles,
  id_usuario,
  nombre,
  pm,
  user_name,
  user_email
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/tracker/proyectos/events`,
      {
        id_trabajo,
        id_empresa: null,
        etapa,
        estatus,
        detalles,
        id_usuario,
        nombre,
        pm,
        user_name,
        user_email,
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al actualizar el evento del tracker del proyecto:",
      error
    );
    throw error;
  }
};

export const updateTrackerProviderEvents = async (
  API_URL,
  id_empresa,
  etapa,
  estatus,
  detalles,
  id_usuario,
  nombre,
  user_email,
  user_name,
  empresa_email
) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/tracker/proveedores/events`,
      {
        id_trabajo: null,
        id_empresa,
        etapa,
        estatus,
        detalles,
        id_usuario,
        nombre,
        user_email,
        user_name,
        empresa_email,
      },
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error al actualizar el evento del tracker del proveedore:",
      error
    );
    throw error;
  }
};

export const deleteNotification = async (API_URL, id) => {
  try {
    const response = await axios.delete(`${API_URL}/api/notifications/${id}`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al eliminar la notificación:", error);
  }
};

export const markAsRead = async (API_URL, id) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/notifications/mark-as-read/${id}`,
      {},
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al marcar la notificación como leída:", error);
  }
};

export const markAsUnread = async (API_URL, id) => {
  try {
    const response = await axios.post(
      `${API_URL}/api/notifications/mark-as-unread/${id}`,
      {},
      {
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al marcar la notificación como no leída:", error);
  }
};

export const getTiposNotificaciones = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/tipos-notificacion`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener los tipos de notificaciones:", error);
  }
};

export const enviarNotificacion = async (
  API_URL,
  notificacion,
  imagenNotificacion
) => {
  try {
    const formData = new FormData();
    formData.append("notificacion", JSON.stringify(notificacion));
    if (imagenNotificacion) {
      formData.append(
        "imagenNotificacion",
        imagenNotificacion,
        imagenNotificacion.name
      );
    }

    const response = await axios.post(
      `${API_URL}/api/enviar-notificacion`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
        withCredentials: true,
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error al enviar la notificación:", error);
    throw error;
  }
};

export const getOldNotifications = async (API_URL) => {
  try {
    const response = await axios.get(`${API_URL}/api/obtener-notificaciones`, {
      withCredentials: true,
    });
    return response.data;
  } catch (error) {
    console.error("Error al obtener las notificaciones antiguas:", error);
  }
};
